import HeroImage from '../../../variants/HeroImage';
import LongformGallery from '../../../variants/LongformGallery';
import LongformRow from '../../../variants/LongformRow';
import ParallaxImageRight from '../../../variants/ParallaxImageRight';
import CharterSpecialFeaturesRow from '../../../variants/CharterSpecialFeaturesRow';
import CenteredCarousel from '../../../variants/CenteredCarousel';
import StandFirstTextblock from '../../../variants/StandFirstTextblock';
import DropCapTextBlock from '../../../variants/DropCapTextBlock';

const variants = {
  heroImage: HeroImage,
  longformGallery: LongformGallery,
  longformRow: LongformRow,
  parallaxImageTextRight: ParallaxImageRight,
  'charter-special-features-row': CharterSpecialFeaturesRow,
  'centered-carousel': CenteredCarousel,
  standFirstTextBlock: StandFirstTextblock,
  dropCapTextBlock: DropCapTextBlock
};

export default variants;
